import { LoadingButton } from '@mui/lab';
import { Box, Button, Grid } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { GeneralSelectMenu, GeneralUpload } from 'src/components/general';
import { FormProvider, RHFTextField } from 'src/components/hook-form';
import { NOTIFICATION_STYLE_LIST } from 'src/constants/queryKeys';
import { networkCreateNotificationStyle, networkUpdateNotificationStyle } from 'src/network/notification-style-list';
import useFormsModalStore from 'src/store/forms';
import { getDefaultValues } from './defaultValues';

const notificationStyleTypes = [
  { id: 1, title: 'مربعی' },
  { id: 2, title: 'مستطیل افقی' },
  { id: 3, title: 'مستطیل عمودی' },
];

const NotificationStyleForm = () => {
  const { modal, closeModal } = useFormsModalStore();

  const { enqueueSnackbar } = useSnackbar();

  const queryClient = useQueryClient();

  const notificationStyleData = modal?.data;
  const defaultValues = getDefaultValues(notificationStyleData);
  const isEditMode = notificationStyleData;

  const [selectedNotificationStyleType, setSelectedNotificationStyleType] = useState(
    notificationStyleData?.NotificationStyleType || notificationStyleTypes[0]?.id
  );

  const methods = useForm({
    // resolver: yupResolver(schema), // todo schema
    defaultValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { isSubmitting },
    setValue,
    trigger,
  } = methods;

  // ---------------------------------------------------------------

  const onSubmit = async (values, event) => {
    const PAYLOAD = {
      ...values,
      NotificationStyleType: selectedNotificationStyleType,
    };

    try {
      if (isEditMode) {
        const res = await networkUpdateNotificationStyle(notificationStyleData?.NotificationStyleID, PAYLOAD);
        if (res.data?.items?.ResultID !== -1) {
          enqueueSnackbar('فریم موردنظر با موفقیت ویرایش شد');
          if (event.nativeEvent.submitter.name === 'save') {
            closeModal();
            reset();
            await queryClient.invalidateQueries([NOTIFICATION_STYLE_LIST]);
          }
        } else {
          enqueueSnackbar('خطایی رخ داد !', { variant: 'error' });
        }
      } else {
        const res = await networkCreateNotificationStyle(PAYLOAD);
        if (res.data?.items?.ResultID !== -1) {
          enqueueSnackbar('فریم موردنظر با موفقیت ایجاد شد');
          if (event.nativeEvent.submitter.name === 'save') {
            closeModal();
          }
          reset();
          await queryClient.invalidateQueries([NOTIFICATION_STYLE_LIST]);
        } else {
          enqueueSnackbar('خطایی رخ داد !', { variant: 'error' });
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Box sx={{ p: 3 }}>
            <Box
              sx={{
                display: 'grid',
                columnGap: 2,
                rowGap: 3,
                gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(2, 1fr)' },
              }}
            >
              <RHFTextField name="NotificationStyleLable" type="text" label="عنوان" />

              <GeneralSelectMenu
                label="نوع فریم"
                name="NotificationStyleType"
                options={notificationStyleTypes}
                value={selectedNotificationStyleType}
                onChangeValue={setSelectedNotificationStyleType}
              />

              <GeneralUpload
                label="تصویر فریم"
                id="notification-style-image-url"
                name="NotificationStyleImageUrl"
                afterChangeAction={(res) => {
                  setValue('NotificationStyleImageUrl', res);
                  trigger('NotificationStyleImageUrl');
                }}
              />

              <div />

              <RHFTextField name="NotificationStylePaddingTop" type="text" label="فاصله داخلی از بالا" />
              <RHFTextField name="NotificationStylePaddingButtom" type="text" label="فاصله داخلی از پایین" />

              <RHFTextField name="NotificationStylePaddingLeft" type="text" label="فاصله داخلی از چپ" />
              <RHFTextField name="NotificationStylePaddingRight" type="text" label="فاصله داخلی از راست" />
            </Box>

            <div className="flex items-center gap-4 mt-6">
              <LoadingButton type="submit" variant="contained" name="save" loading={isSubmitting}>
                ذخیره
              </LoadingButton>
              <LoadingButton type="submit" variant="contained" color="info" name="saveAndContinue" loading={isSubmitting}>
                {isEditMode ? 'ذخیره و ادامه ویرایش' : 'ذخیره و ایجاد بعدی'}
              </LoadingButton>
              <Button onClick={closeModal} variant="contained" color="error">
                انصراف
              </Button>
            </div>
          </Box>
        </Grid>
      </Grid>
    </FormProvider>
  );
};

export default NotificationStyleForm;
